<template>
    <LoginContent>
        <div class="row justify-content-center">
            <div class="col-12 col-lg-8 col-xl-8" v-if="!cambiada">
                <div class="min-height-100vh has-header d-flex align-items-center">
                    <div class="form-content form-team-content w-100 white-content">
                        <div class="h1 mb-4 text-center text-uppercase">Reestablecer contraseña</div>
                        <div class="thumb-container absolute" :style='"background-image: url(" + footer.logo + ")"'></div>
                        <form class="w-100" @submit.prevent="reestablecer">
                            <div class="form-group">
                                <label for="email">Email</label>
                                <input type="email" name="email" v-model="login_data.email">
                            </div>
                            <div class="form-group">
                                <label for="password">Nueva contraseña</label>
                                <input type="password" name="password" v-model="login_data.password">
                            </div>
                            <div class="form-group">
                                <label for="password">Confirmar nueva contraseña</label>
                                <input type="password" name="password" v-model="login_data.password_confirmation">
                            </div>

                            <div class="form-group" v-if="errors">
                                <div class="alert alert-danger" role="alert">
                                    <ul>
                                        <template v-for="(error, index) in errors.errors">
                                            <li :key="index">
                                                {{ error[0] }}
                                            </li>
                                        </template>                                                
                                    </ul>
                                </div>
                            </div>
                            
                            <div class="row justify-content-md-between">
                                <div class="col-12 col-lg-6">
                                    <button type="submit" class="button" name="button">Enviar</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-8 col-xl-8" v-if="cambiada">
                <div class="min-height-100vh has-header d-flex align-items-center">
                    <div class="form-content form-team-content w-100 white-content">
                        <div class="h3 mb-4 text-center text-uppercase">La contraseña se ha actualizado</div>
                        <div class="mb-4 text-center">
                            <p>
                                Has establecido una nueva contraseña y has iniciado sesión.
                            </p>
                        </div>
                        <div class="mb-4 text-center">
                            <router-link
                                class="button"
                                :to="{ name: 'perfil' }"
                            >
                                Ir a mi historial
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </LoginContent>
</template>

<script>
import LoginContent from '@/components/frontend/components/LoginContent';

export default {
    data() {
        return {
            login_data: {
                token: this.$route.query.token
            },
            mensaje: null,
            cambiada: null,
            errors: null
        }
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
        footer() {
            return this.$store.getters.getFooter;
        }
    },
    methods: {
        reestablecer() {
            this.login_data.filters = {
                tid : this.configuracion.hash_teatro
            }
            this.$store.dispatch(this.config.getVuexAlias('reset-password'), this.login_data).then(res => {
                this.cambiada = true;
            }).catch(error => {
                this.errors = error.response.data;                
            });
        }
    },
    components: {
        LoginContent
    }
}
</script>
